import LinearProgress from '@mui/material/LinearProgress';

const Loader = () => {
    return (
        <LinearProgress
            sx={{
                color: 'primary',
                '& .MuiLinearProgress-bar': {
                    backgroundColor: '#1BABE2'
                }
            }}
        />
    );
};

export default Loader;
